import _get from 'lodash/get'

import { generateGetFlowValueFunctions } from '@flows/insurance/utils'

import { FAILURE_REASONS } from './constants'
import type { GetFailureReason } from './types'

const getLegalFailureReason: GetFailureReason = ({
  formValues,
  stepTransformer = (step: string) => step,
  currentStep,
  productKey = 'legal_comfort_3_basic_roland_de',
}) => {
  const { getParamPath } = generateGetFlowValueFunctions(productKey)

  switch (currentStep) {
    case stepTransformer('legal_insurance_cancelled_by'): {
      const previousInsuranceCancelledByInsurer = _get(
        formValues,
        getParamPath('insurance_was_voided_before')
      )
      return {
        reason: FAILURE_REASONS.PREVIOUS_INSURANCE_VOIDED,
        extraData: { previousInsuranceCancelledByInsurer },
      }
    }
    case stepTransformer('legal_damages'): {
      const selectedNumberOfPreviousClaims = _get(
        formValues,
        getParamPath('number_of_claims_in_last_5y')
      )
      return {
        reason: FAILURE_REASONS.TOO_MANY_PREVIOUS_CLAIMS,
        extraData: { selectedNumberOfPreviousClaims },
      }
    }
    default: {
      break
    }
  }
}
export default getLegalFailureReason
